import { Component, Inject, Injector, OnInit, Optional } from '@angular/core';
import {
  OKTA_AUTH,
  OktaAuthConfigService,
  OktaCallbackComponent,
} from '@okta/okta-angular';
import OktaAuth from '@okta/okta-auth-js';
import { AuthService } from '../../services';

/*
  This component is here only to activate an action after logging in through the okta sign-in flow
*/
@Component({
  template: '',
  standalone: false,
})
export class CustomAuthCallbackComponent
  extends OktaCallbackComponent
  implements OnInit
{
  constructor(
    configService: OktaAuthConfigService,
    @Inject(OKTA_AUTH) oktaAuth: OktaAuth,
    private readonly authService: AuthService,
    @Optional() injector?: Injector
  ) {
    super(configService, oktaAuth, injector);
  }

  public ngOnInit(): Promise<void> {
    return super.ngOnInit().then(() => {
      this.onAuthSuccessful();
    });
  }

  private onAuthSuccessful() {
    this.authService.setOktaFlow();
  }
}
